import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BUSINESS_ROUTE } from 'data/global';
import { Listing } from 'models/Listing';
import CorrectTierCard from 'components/CorrectTierCard';
import env from 'env';
import useListingCardPlaceholder from 'hooks/useListingCardPlaceholder';
import api from 'api';

import './NotFoundPage.styles.scss';
import './NotFoundPage.styles.responsive.scss';

type NotFoundPageProps = {
  className?: string;
};

const LIMIT = '4';

const NotFoundPage: React.FC<NotFoundPageProps> = (props) => {
  const { className } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [listings, setListings] = useState<Listing[]>([]);

  const classes = classNames('not-found-page', className);

  const { t } = useTranslation();

  const placeholder = useListingCardPlaceholder(+LIMIT);

  const BackLinks = useMemo(
    () => (
      <div className="back-links">
        <Link
          to={BUSINESS_ROUTE}
          className="ncoded-button ncoded-button--solid"
        >
          {t('businessesForSaleExact')}
        </Link>

        <a href={env.URL} className="ncoded-button ncoded-button--outline">
          {t('backToHome')}
        </a>
      </div>
    ),
    [t],
  );

  const Listings = useMemo(
    () =>
      isLoading
        ? placeholder
        : listings?.map((listing) => (
            <CorrectTierCard
              key={listing._id}
              listing={listing}
              updateListing={(listingId, updatedValues) =>
                setListings((old) =>
                  old.map((el) =>
                    el._id !== listingId ? el : { ...el, ...updatedValues },
                  ),
                )
              }
            />
          )),
    [isLoading, listings, placeholder],
  );

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const {
          data: { items },
        } = await api.listings.getLatestListings({ $limit: LIMIT });
        setListings(items);
      } catch {
        return;
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <div className={classes}>
      <h1>{t('pageNotFindTitle')}</h1>
      <p>{t('pageNotFind')}</p>
      {BackLinks}
      <h2>{t('recentlyPublishedListings')}</h2>
      {Listings}
      {BackLinks}
    </div>
  );
};

export default NotFoundPage;
